module.exports = __webpack_public_path__ + "img/pic5.4100546f.png";